<div class="cookie-info" *ngIf="show">
  <div class="custom-backdrop"></div>
  <div>Vous avez déjà consulté 1 article gratuitement cette semaine, pour voir cet article:</div>
	<button ion-button class="createuser" (click)="goToBoutique()">S'ABONNER</button>
	<button ion-button class="createuser" (click)="goToLogin()">SE CONNECTER</button>
</div>
